  <template>
    <div v-if="!!dashboardUser" class="card trf-cardTotalizador">
      <div class="card-content trf-cardTotalizador-conteudo">
        <div class="is-flex is-flex-direction-column trf-cardTotalizador-flex">
          <div class="trf-cardTotalizador-usuario is-flex is-align-items-center pb-4">
            <div class="trf-cardTotalizador-usuario-foto is-flex-shrink-1">
              <TrfFotoUsuario class="mr-3" :fotoID="dashboardUser.fotoId" :isRounded="true" :useTooltip="false" :height="40" :width="40"/>
            </div>
            <p class="trf-cardTotalizador-usuario-nome is-flex-grow-1 is-dark" :title="dashboardUser.usuarioId == 0? 'Sem responsável' : dashboardUser.nome">
              {{dashboardUser.usuarioId == 0? 'Sem responsável' : dashboardUser.nome}}
            </p>
          </div>
          <div class="trf-cardTotalizador-totalizadores">
            <div class="trf-cardTotalizador-totalizadores-item py-1 columns" @click="enviaDados(statusEnum,dashboardUser)" v-for="(quantidade, statusEnum) in totalizadoresValidos" :key="statusEnum">
              <div class="column py-0 is-clickable">{{ statusFormatado(statusEnum)}}</div>
              <div class="column py-0 is-narrow is-clickable">{{quantidade}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import TrfFotoUsuario from './FotoUsuario.vue';
  import { toastUtils } from '../../util/toast.utils';
  import { TrfMixinInfiniteScroll } from '../../mixins/infinitescroll';
  import { statusTarefas } from '../../util/statusTarefas.utils';

  export default {
    name: "TrfCardTotalizadorUsuario",
    components: {
      TrfFotoUsuario
    },
    mixins: [TrfMixinInfiniteScroll],
    props: {
      dashboardUser: {
        type: Object,
        required: true
      },
      statusIgnorados: {
        type: Array,
        default: () => ['riscoDeMulta'],
        required: false
      },
      isStretch: {
        type: Boolean,
        default: true,
        required: false
      },
      filtrosGlobais: {},
    },
    data() {
      return {}
    },
    computed: {
    totalizadoresValidos() {
        const totalizadores = Object.assign({}, this.dashboardUser.totalizador);
        this.statusIgnorados.forEach(status => {
          if(totalizadores[status] != null) {
            delete totalizadores[status];
          }
        })
        return totalizadores;
      }
    }, 
    methods: {
      enviaDados(texto) {
        const dados = this.dashboardUser;    
        if (dados.totalizador[texto] > 0) {
          this.$emit('dadosEnviados', texto,dados);
        } else {
          this.alertarStatusQuantidadeZero(); 
        }
      },
      statusFormatado(status) {
        return statusTarefas.obterTexto(status)
      },
      alertarStatusQuantidadeZero() {
        toastUtils.infoToast("Não há tarefas a serem exibidas.")  
      }
    }
  };
  </script>
  <style lang="scss" scoped>
    @import "../../assets/sass/variables.scss";
    .trf-cardTotalizador {
      &-usuario {
        &-nome {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          box-orient: vertical;  
          overflow: hidden;
        }
      }

      &-totalizadores {
        &-item {
          > div {
            a {
              color: hsl(0deg, 0%, 29%) !important
            }
          }
        }
      }      
    }

  </style>